import styled from 'styled-components';
import { useEffect } from 'react';
import { Card, Divider, Form, Spin } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import CompanyList from './CompanyList';
import { getRemittanceCompanies } from '../../methods/redux/reducers/global-webhooks';

export const TableHeader = styled.th`
	padding: 12px 20px;
	text-align: left;
	font-weight: 800;
	color: #262626;
	border-bottom: 1px solid #f0f0f0;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 1fr 1fr 1fr 1fr;
`;

export const StyledFormItem = styled(Form.Item)`
	.ant-row {
		display: block;
	}
`;

const RemittanceCompanies = () => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	const { remittanceCompanies, loadingCompanies } = useAppSelector(
		(store) => store.globalWebhooks
	);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
			});
		} else {
			dispatch(getRemittanceCompanies());
		}
	}, [searchParams, dispatch]);

	return (
		<Card>
			<h1>Switch Wallet Remittance Companies</h1>
			{/* <p>Track and manage your income, expenses, and financial records.</p> */}

			<Divider />

			<p>
				Total of <strong>{remittanceCompanies?.data?.length} items</strong>{' '}
				found
			</p>

			<Divider />

			<br />

			<TableHeader>
				<div>Business Name</div>
				<div>Business Email</div>
				<div>Status</div>
				<div>Created At</div>
			</TableHeader>

			{loadingCompanies ? (
				<Spin size="large" style={{ display: 'block', margin: '40px auto' }} />
			) : (
				<div>
					{remittanceCompanies?.data?.length > 0 &&
						remittanceCompanies?.data?.map((item: any) => (
							<CompanyList key={item.id} item={item} />
						))}
				</div>
			)}

			<br />

			<Divider />
		</Card>
	);
};

export default RemittanceCompanies;
